'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "date", "skipDataCurrent", "ariaLabelFormat"];
import * as React from 'react';
import { createSelector, useStore } from '@base-ui/utils/store';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { useCompositeListItem } from "../../base-ui-copy/composite/list/useCompositeListItem.mjs";
import { useAdapterContext } from "../../use-adapter-context/index.mjs";
import { useEventCalendarStoreContext } from "../../use-event-calendar-store-context/index.mjs";
import { getCalendarGridHeaderCellId } from "../../internals/utils/accessibility-utils.mjs";
import { useCalendarGridRootContext } from "../root/CalendarGridRootContext.mjs";
import { schedulerNowSelectors } from "../../scheduler-selectors/index.mjs";
import { EventCalendarState as State } from "../../use-event-calendar/index.mjs";
const selectorIsCurrentDate = createSelector((state, date, skipDataCurrent) => !skipDataCurrent && schedulerNowSelectors.isCurrentDay(state, date));
export const CalendarGridHeaderCell = /*#__PURE__*/React.forwardRef(function CalendarGridHeaderCell(componentProps, forwardedRef) {
  const adapter = useAdapterContext();
  const {
      // Rendering props

      // Internal props
      date,
      skipDataCurrent,
      ariaLabelFormat = adapter.formats.weekday
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const store = useEventCalendarStoreContext();
  const {
    id: rootId
  } = useCalendarGridRootContext();
  const isCurrentDay = useStore(store, selectorIsCurrentDate, date.value, skipDataCurrent);
  const {
    ref: listItemRef,
    index
  } = useCompositeListItem();
  const id = getCalendarGridHeaderCellId(rootId, index);
  const props = {
    role: 'columnheader',
    id,
    'aria-label': `${adapter.formatByString(date.value, ariaLabelFormat)}`
  };
  const state = React.useMemo(() => ({
    current: isCurrentDay
  }), [isCurrentDay]);
  return useRenderElement('div', componentProps, {
    state,
    ref: [forwardedRef, listItemRef],
    props: [props, elementProps]
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridHeaderCell.displayName = "CalendarGridHeaderCell";